'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "className", "Content", "onOpenChange"];
import classNames from 'classnames';
import { EDITABLE_CONTROLS_TRANSITION_TIMING } from 'HubStyleTokens/times';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Controllable from '../decorators/Controllable';
import AccordionTransition from '../transitions/AccordionTransition';
import { toPx } from '../utils/Styles';
import { jsx as _jsx } from "react/jsx-runtime";
const EDITABLE_CONTROLS_TRANSITION_TIMEOUT = parseInt(EDITABLE_CONTROLS_TRANSITION_TIMING, 10);
const DRAWER_PADDING_Y = 8;
const SlideoutTransitionWrapper = styled(AccordionTransition.defaultProps.Wrapper).withConfig({
  displayName: "UISlideoutDrawer__SlideoutTransitionWrapper",
  componentId: "sc-1xv39no-0"
})(["height:auto;transition:", ";transform:", ";"], ({
  duration,
  measuredHeight,
  transitionActive,
  opening
}) => {
  if (!transitionActive || measuredHeight == null) return 'none';
  // On slide-down, fade in after a delay. On slide-up, fade out fast right away.
  const opacityDuration = opening ? duration * 0.7 : duration * 0.3;
  const opacityDelay = opening ? duration - opacityDuration : 0;
  return `opacity ${opacityDuration}ms ease-out ${opacityDelay}ms, transform ${duration}ms`;
}, ({
  open,
  measuredHeight,
  transitioning
}) => transitioning && (open ? `translateY(0)` : `translateY(${toPx(-1 * (measuredHeight - DRAWER_PADDING_Y))})`));
const DrawerContent = styled.div.withConfig({
  displayName: "UISlideoutDrawer__DrawerContent",
  componentId: "sc-1xv39no-1"
})(["padding-top:12px;padding-bottom:12px;"]);
const UISlideoutDrawer = props => {
  const {
      children,
      className,
      Content
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(AccordionTransition, Object.assign({}, rest, {
    className: classNames('uiEditableControlsStage', className),
    duration: EDITABLE_CONTROLS_TRANSITION_TIMEOUT,
    Wrapper: SlideoutTransitionWrapper,
    children: /*#__PURE__*/_jsx(Content, {
      className: "private-slideout-drawer__content",
      children: children
    })
  }));
};
UISlideoutDrawer.propTypes = {
  Content: PropTypes.elementType.isRequired,
  onOpenChange: PropTypes.func,
  open: PropTypes.bool,
  children: PropTypes.node
};

/* eslint-disable-next-line hubspot-dev/no-default-props-assignment */
UISlideoutDrawer.defaultProps = {
  Content: DrawerContent,
  open: false
};
UISlideoutDrawer.displayName = 'UISlideoutDrawer';
export default Controllable(UISlideoutDrawer, ['open']);